module.exports = __webpack_public_path__ + "officialStatic/img/money-three.6cd0f31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/money-three.png
// module id = uHx7
// module chunks = 0